import $ from 'jquery'

const { __ } = wp.i18n
import { Modal } from 'bootstrap'

const body = document.body
const object = vnObject

const setThemeVars = () => {
  const documentWidth = document.documentElement.clientWidth
  const width = Math.abs(window.innerWidth - documentWidth)
  body.style.setProperty('--scrollbar-width', `${width}px`)

  const mainContainer = document.querySelector('#colophon > .container')
  const mainContainerWidth = mainContainer.clientWidth

  const col = document.querySelector('.vn-col-sizer')
  const colWidth = col.clientWidth

  const headerContainer = document.querySelector('.site-header')
  const headerContainerHeight = headerContainer.clientHeight

  body.style.setProperty(
    '--space-width',
    `${(documentWidth - mainContainerWidth) / 2 + 20}px`
  )

  body.style.setProperty('--container-width', `${mainContainerWidth}px`)
  body.style.setProperty('--main-width', `${documentWidth}px`)
  body.style.setProperty('--col-width', `${colWidth}px`)
  body.style.setProperty('--header-height', `${headerContainerHeight}px`)
}

setThemeVars()
window.addEventListener('load', setThemeVars)
window.addEventListener('resize', setThemeVars)

$('.vn-btn-terms button').on('click', function (e) {
  e.preventDefault()
  if ($(this).attr('data-url') != undefined) {
    window.location.href = $(this).attr('data-url')
  }
})

const allModals = document.querySelectorAll('[data-bs-toggle="modal"]')
if (allModals.length) {
  ;[...allModals].map((modal) => {
    new Modal(modal)
  })
}

var menuBtn = $('.site-header__menu')
$('#menuOffcanvas').on('show.bs.offcanvas', function () {
  menuBtn.addClass('open')
  menuBtn.find('i').removeClass('vn-icons-menu')
  menuBtn.find('i').addClass('vn-icons-close')
})

$('#menuOffcanvas').on('hide.bs.offcanvas', function () {
  menuBtn.removeClass('open')
  menuBtn.find('i').removeClass('vn-icons-close')
  menuBtn.find('i').addClass('vn-icons-menu')
})

$('.vn-excerpt__more').on('click', function () {
  const button = $(this)
  const button_parent = button.parents('.vn-excerpt')

  if (button_parent.hasClass('vn-excerpt--active')) {
    button.html(object.readMore)
  } else {
    button.html(object.readLess)
  }

  button_parent.toggleClass('vn-excerpt--active')
})

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[href^="tel:"]').forEach((el) => {
    el.classList.add(object.gtmPhoneClass)
  })
  document
    .querySelectorAll('[href^="https://www.google.com/maps/"]')
    .forEach((el) => {
      el.classList.add(object.gtmItineraryClass)
    })
  document.querySelectorAll('[href^="mailto:"]').forEach((el) => {
    el.classList.add(object.gtmMailClass)
  })
  document
    .querySelector('footer li.cookies')
    .addEventListener('click', function (e) {
      e.preventDefault()
      openAxeptioCookies()
    })

  const loginForm = document.querySelector('.woocommerce-form-login-toggle')
  if (loginForm) {
    loginForm
      .querySelector('a.showlogin')
      .addEventListener('click', function (e) {
        e.target.setAttribute(
          'aria-expanded',
          !JSON.parse(e.target.getAttribute('aria-expanded'))
        )
      })
  }
})
